import { render, staticRenderFns } from "./VireedPlayer.vue?vue&type=template&id=cb886476&scoped=true&"
import script from "./VireedPlayer.vue?vue&type=script&lang=js&"
export * from "./VireedPlayer.vue?vue&type=script&lang=js&"
import style0 from "./VireedPlayer.vue?vue&type=style&index=0&id=cb886476&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb886476",
  null
  
)

export default component.exports